import { action, computed, observable } from "mobx";

import { KnownLocale } from "nvent-web/i18n";
import Api from "nvent-web/services/Api";

import { UserStore } from "./User";

export class AppStore {
  @observable
  isSideMenuVisible = false;

  @computed
  get locale(): KnownLocale {
    return this.user.locale;
  }

  constructor(private user: UserStore, private api: Api) {}

  @action.bound
  toggleSideMenu(visible = !this.isSideMenuVisible) {
    this.isSideMenuVisible = visible;
  }

  showSideMenu = () => this.toggleSideMenu(true);
  hideSideMenu = () => this.toggleSideMenu(false);
}

export default AppStore;
